/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Tab_Ocop1Inputs */

const vi_sitesettings_tab_ocop1 = /** @type {(inputs: Sitesettings_Tab_Ocop1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCOP`)
};

/**

* @param {Sitesettings_Tab_Ocop1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_tab_ocop1 = /** @type {((inputs?: Sitesettings_Tab_Ocop1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Tab_Ocop1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_tab_ocop1(inputs)
});
export { sitesettings_tab_ocop1 as "siteSettings_tab_ocop" }